import "../css/style.scss"
// For translation use the __(string, domain) function
//const __ = wp.i18n.__
import $ from "jquery";



//Modules 
import "./modules/Slider.js";
import "./modules/Popup.js";
import "./modules/Switch.js";
import "./modules/FileUpload.js";
import "./modules/Form.js";
import "./modules/NotificationBanner.js";
import "./modules/Faq.js";
import "./modules/Nav-menu-mobile.js";
import "./modules/BackdropOverlay.js";
import "./modules/CountAnimation.js";
import "./modules/UitlegVideoCounter.js";
import Search from "./modules/Search.js";


// Blocks 
import "./blocks/Contact.js";
import "./blocks/Nieuwsbrief.js";
import "./blocks/Platform.js";
import "./blocks/JoinUs.js";
import "./blocks/HorizontallyMovingText.js";
import "./blocks/Aanmelden.js";
import "./blocks/UniqueSellingPoints.js";
import "./blocks/Vaardigheidsniveau.js";
import "./blocks/Interviews.js";
import "./blocks/Eigenschappen.js";
import "./blocks/Evenementen.js";
import "./blocks/ZoStartJe.js";
import "./blocks/Recycle.js";

// Pages 
import "./pages/Inspiratiemagazine.js";
import "./pages/GemeenteSingle.js";
import "./pages/ActiviteitArchive.js";
import "./pages/ActiviteitSingle.js";


// Document ready
$(function(){
    let viewportWidth = $(window).width();
    
    const search = new Search();

});

$('.stop-propagation').on('click', function(e){
    e.stopPropagation();
});





$('.open-search').on('click', function(e){
    e.stopPropagation();
    $(this).find('.search-menu').css('display', 'flex');
    $('.site-overlay-blur').addClass('active');
});

$('.search-menu').on('click', function(e){
    e.stopPropagation();
});

$(window).on('click', function(){
    $('.search-menu').css('display', 'none');
    $('.site-overlay-blur').removeClass('active');
});



// General function for one element triggering active on another
$('[data-target]').on('click', function(){
    let target = $(this).data('target');
    let $target = $('.' + target);

    if ($target.hasClass('active')){
        $target.removeClass('active');
    }
    else{
        $target.addClass('active');
        $target.removeClass('hide');
    }

    if ($(this).data('remove')){
        $(this).remove();
    }
});



